export default "__VITE_ASSET__b1a507d2__"